import React from 'react';
import { stats } from '@/data/mock';
import { cn } from '@/lib/utils';

export const StatsSection = ({ className }) => {
  return (
    <section className={cn('py-16 bg-gray-900 relative overflow-hidden', className)}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-red-600 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-600 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center group"
            >
              <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-2 group-hover:text-red-500 transition-colors duration-300">
                {stat.value}
              </div>
              <div className="text-gray-400 text-sm md:text-base uppercase tracking-wider">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
